









import { Component, Vue } from 'vue-property-decorator'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import { DeleteMember, QueryMemberList, UpdateMemberStatus } from '@/api'
import { DateFormat } from '@/utils/date/DateUtil'
import { Message, MessageBox } from 'element-ui'
import EditMemberDialog from './EditMemberDialog.vue'
import { MemberStatusFormat,MemberIsDemotionFormat} from '@/utils/tyepconvert'

@Component({
  components: {
    VQuery,
    VTable,
    EditMemberDialog,
  },
})
export default class VideoList extends Vue {
  private queryParam = {
    startRow: 1,
    limit: 10,
    orderBy: " sequence "
  }
  private tableTotal = 0
  private tableData = []
  private tableCurrntPage = 1

  // 查询条件
  private queryModels: Array<QueryModel> = [{ title: '会员名称', param: 'name' }]
  // 全局操作
  private queryOperation: Array<TableOperation> = [{ title: '创建会员', type: 'primary', click: this.openCreateVideo }]
  // 数据表头 -
  // 视频比例 ()
  private tableHander: Array<TableHander> = [
    { title: '序号', param: 'id', type: 'index' },
    { title: '会员名称', param: 'name' },
    { title: '指定区域商品要求', param: 'activityName' },
    { title: '贡献值要求', param: 'contributionNumber' },
    { title: '推荐下单人数', param: 'directNumber' },
    { title: '购买订单数', param: 'orderNumber' },
    { title: '序列', param: 'sequence' },
    // { title: '层级', param: 'level' },
    { title: '状态', param: 'status' , formatter: MemberStatusFormat},
    { title: '是否允许降级', param: 'isDemotion' , formatter: MemberIsDemotionFormat},
    { title: '图标icon', param: 'icon', type: 'image' },
    {
      title: '操作',
      operation: [
        { title: '编辑', click: this.openEditVideo },
        {
          title: '启用',
          click: this.updateOpenStatus,
          show: function (data) {
            return data.status != 1
          },
        },
        {
          title: '禁用',
          click: this.updateCloseStatus,
          show: function (data) {
            return data.status == 1
          },
        },
        { title: '删除', click: this.delete },
      ],
    },
  ]

  public async created() {
    this.loadData()
  }

  private openCreateVideo() {
    const d = this.$refs.EditMemberDialog as EditMemberDialog
    d.open({}, false)
  }

  private delete(data: any) {
    if(data.id == 1){
       Message.error('默认会员不能删除')
      return;
    }
    MessageBox.confirm('确定要删除吗？', '提示', {
      type: 'warning',
    }).then(async () => {
      const ruslt = await DeleteMember({ id: data.id })
      if (ruslt) {
        Message.success('删除成功')
        this.loadData()
      }
    })
  }

  private async updateOpenStatus(data: any) {
    await UpdateMemberStatus({
      id: data.id,
      status: 1,
    })
    this.loadData()
  }
  private async updateCloseStatus(data: any) {
    await UpdateMemberStatus({
      id: data.id,
      status: 0,
    })
    this.loadData()
  }

  public openEditVideo(data: any) {
    const d = this.$refs.EditMemberDialog as EditMemberDialog
    d.open(data, true)
  }

  public async loadData() {
    const param = { ...this.queryParam }
    param.startRow =  (this.tableCurrntPage - 1) * (param.limit || 12)
    const result = await QueryMemberList(param)
    this.tableTotal = result.total
    this.tableData = result.list
  }

  public search() {
    console.log(this.queryParam)
    this.tableCurrntPage = 1
    this.loadData()
  }
  // 分页导航改变
  public pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  public sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }
}
